import { render, staticRenderFns } from "./PenTest.vue?vue&type=template&id=cdb270a8&scoped=true&"
import script from "./PenTest.vue?vue&type=script&lang=js&"
export * from "./PenTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb270a8",
  null
  
)

export default component.exports